import React, {useState} from 'react';
import ExportIcon from "../../Assets/Download.svg"
// modal
import Modal from "../Modal";
import {DownloadServiceRequest} from "../../Redux/Actions/ServiceRequestAction";

function Export(props) {
    const [open, setOpen] = useState(false);
    const [userType, setUserType] = useState('');
    const [date, setDate] = useState('');
    const CloseModal = (e, type) => {
        setOpen(false);
         e.preventDefault();
         if(type === 'add_yes'){
           const data = {
                user_type: props.user_type,
                date: props.date,
            };
             props.DownloadServiceRequest(data);
            };
           
        }
        
        
    const handleUserType = (e) => {
    setUserType(e)
    }

    const handleCsvDate = (s_d, e_d) => {
    setDate(`${s_d}, ${e_d}`)
    }

    const UserTypeOptions = [
        { value: 'All', label: 'All', id: '1' },
        { value: 'Personal Banking', label: 'Personal Banking', id: '2' },
        { value: 'Business', label: 'Business', id: '3' },
    ];

    const downloadCSV = () => {
        const data =  {
            date : date,
            userType  : userType
        }
        DownloadServiceRequest(data);
    }

    const colourStyles = {
        control: (styles, state) => (
            {
                ...styles,
                backgroundColor: '#3C3C3C',
                border: state.isFocused ? '1px solid #A0A0A0' : '1px solid #3C3C3C',
                transition: 'all 0.25s linear 0s',
                "&:hover": {
                    border: '1px solid #A0A0A0'
                },
                padding: '4px 6px',
                boxShadow: state.isFocused ? null : null,
            }),
    };
    
    return (
        <div>
            <img
                src={ExportIcon}
                onClick={() => setOpen(true)}
                alt='UploadIcon'
                className='ml-3 cursor-pointer'
            />
            {
                open && <Modal
                    Type='excel-export'
                    Close={(e) => CloseModal(e)}
                    handleUserType={(e)=> handleUserType(e)}
                    handleDate={(e)=> handleCsvDate(e)}
                    UserTypeOptions={UserTypeOptions}
                    userType={userType}
                    Download={(e) => {downloadCSV(e)}}
                    UserColorStyles={colourStyles}
                    Export={(e, fileinfo) => props.Export(e, fileinfo)}
                />
            }
        </div>
    ); 


       
    
}

export default Export;